import { useState } from "react";
import styles from "./ContactForm.module.css";
import emailSvg from "../../Assests/icons/emailSvg.svg";
import phoneSvg from "../../Assests/icons/ic-tel.svg";
import mapSvg from "../../Assests/icons/mapSvg.svg";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    company: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = "recipient@example.com"; // Change this to your desired email
    const subject = encodeURIComponent("Inquiry from Website");
    const body = encodeURIComponent(
      `Full Name: ${formData.fullName}\nCompany: ${formData.company}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nAddress: ${formData.address}\nMessage: ${formData.message}`
    );
    const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Let's talk on something great together</h2>
      <p className={styles.subheading}>We'd love to hear from you!</p>

      {/* Contact Form */}
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.row}>
          <div className={styles.inputGroup}>
            <label htmlFor="fullName">Full Name</label>
            <input
              type="text"
              name="fullName"
              id="fullName"
              className={styles.input}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="company">Company</label>
            <input
              type="text"
              name="company"
              id="company"
              className={styles.input}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.inputGroup}>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              name="email"
              id="email"
              className={styles.input}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="phone">Phone Number</label>
            <input
              type="text"
              name="phone"
              id="phone"
              className={styles.input}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="address">Address</label>
          <input
            type="text"
            name="address"
            id="address"
            className={styles.input}
            onChange={handleChange}
          />
        </div>

        <div className={styles.inputGroup}>
          <label htmlFor="message">Your Message</label>
          <textarea
            name="message"
            id="message"
            className={styles.textarea}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className={styles.newbutton}>
          Submit
        </button>
      </form>
      <div className={styles.contactDetails}>
            <div className={styles.contactItem}>
              <img src={emailSvg} alt="Email Icon" className={styles.icon} />
              <a
                title="email"
                href="mailto:sales@hyproc-intl.com"
                className={styles.emailIcon}
              >
                
                sales@hyproc-intl.com
              </a>
            </div>
            <div className={styles.contactItem}>
              <img src={phoneSvg} alt="Phone Icon" className={styles.icon} />
              <span>+44 1895 699799</span>
            </div>
            <div className={styles.contactItem}>
              <img src={mapSvg} alt="Map Icon" className={styles.icon} />
              <span>
                Hyproc International Limited<br />
                Eagle Court 9 Vine Road<br />
                Uxbridge UB8 1QE
              </span>
            </div>
          </div>
    </div>
  );
};

export default ContactForm;
